// extracted by mini-css-extract-plugin
module.exports = {"item":"Style_item__2Wm0_","title":"Style_title__2ppNQ","detail":"Style_detail__3XgxF","options":"Style_options__1FUp_"};